export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";